import { Product } from "@organizations/models";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";

export interface OrganizationAssociatedProductState extends EntityState<Product> {
  loading: boolean;
  loaded: boolean;
}

export const organizationAssociatedProductAdapter: EntityAdapter<Product> =
  createEntityAdapter<Product>({
    selectId: (organizationAssociatedProduct: Product) => organizationAssociatedProduct.id,
    sortComparer: (orgAssociatedProduct1, orgAssociatedProduct2) =>
      orgAssociatedProduct1.name.localeCompare(orgAssociatedProduct2.name)
  });
